import React from "react";

const TrashIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>trash-icon</title>
      <path
        d="M15 4v10c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V4c-.552 0-1-.448-1-1s.448-1 1-1h5c0-1.105.895-2 2-2s2 .895 2 2h5c.552 0 1 .448 1 1s-.448 1-1 1zm-2 0H3v10h10V4zM5 5c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1V6c0-.552.448-1 1-1zm3 0c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1V6c0-.552.448-1 1-1zm3 0c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1V6c0-.552.448-1 1-1z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default TrashIcon;
